'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { ShowcaseStack } from '../ShowcasePair'
import { fetchShowcaseForPage } from '../../lib/showcaseApi'
import './home-v2.css'
import './showcase-stack.css'

// Homepage showcase: the same sticky top-to-bottom card stack as the service
// pages (/services/ghl-setup), for the "home" set managed in /admin
// (Showcase), capped at 10. First paint uses the build-time snapshot handed
// down by app/page.tsx; the live API refreshes it after hydration and never
// blanks it.
const PAGE_KEY = 'home'
const HOME_LIMIT = 10

export default function ShowcaseStackV2({ initialItems = [] }) {
  const [items, setItems] = useState(() => initialItems.slice(0, HOME_LIMIT))

  useEffect(() => {
    let live = true
    fetchShowcaseForPage(PAGE_KEY).then((rows) => {
      if (live && Array.isArray(rows) && rows.length) setItems(rows.slice(0, HOME_LIMIT))
    })
    return () => {
      live = false
    }
  }, [])

  if (!items.length) return null

  return (
    <section className="hv2 hv2-section is-white sk" aria-labelledby="showcase-title">
      <div className="hv2-inner">
        <div className="hv2-head centered" data-rv="0.4">
          <span className="hv2-eyebrow">Shipped evidence</span>
          <h2 id="showcase-title">Built in Public. <span className="hv2-hl">Real Results.</span></h2>
          <p>
            Consumer products running in production at scale, each one the origin of an
            enterprise system. The same engine, two markets, both shipping.
          </p>
        </div>

        <ShowcaseStack items={items} />

        <div className="sk-more">
          <Link href="/case-studies">See all case studies</Link>
        </div>
      </div>
    </section>
  )
}
